import { useWindowDimensions } from './useWindowDimensions'

export type Breakpoints = {
  isMobile: boolean
  isLargeDesktop: boolean
  isTablet: boolean
  isDesktop: boolean
  isTabletOrLess: boolean
  isDesktopOrBigger: boolean
}

export function useBreakpoints(): Breakpoints {
  const { width } = useWindowDimensions()

  const { desktopInPx, tabletInPx, largeDesktopInPx } = {
    desktopInPx: 1280,
    tabletInPx: 768,
    largeDesktopInPx: 1920,
  }

  const isLargeDesktop = width >= largeDesktopInPx
  const isDesktop = width >= desktopInPx
  const isTablet = width >= tabletInPx && width < desktopInPx
  const isMobile = width < tabletInPx
  const isTabletOrLess = width < desktopInPx
  const isDesktopOrBigger = !isTabletOrLess

  return { isMobile, isLargeDesktop, isTablet, isDesktop, isTabletOrLess, isDesktopOrBigger }
}
